<div class="products-panel">
    <div class="btns-filters">
        <div class="filters-left">
            <div class="buscador-event container-form d-flex align-items-center borderInput">
                <i class="fal fa-search search-icon pointer-in"></i>
                <input class="input-custom w-100" type="text" placeholder="Buscar producto"
                    [ngModel]="searchText" (input)="onSearch($any($event.target).value)">
            </div>
            <div class="filter-group">
                <div class="filter-pill" [class.active]="seasonFilter !== ''" (click)="seasonDropdownOpen = !seasonDropdownOpen">
                    <i class="fal fa-calendar-range"></i>
                    <span>{{ seasonFilterLabel }}</span>
                    <i class="fal fa-chevron-down chevron" [class.open]="seasonDropdownOpen"></i>
                </div>
                <div class="filter-dropdown" *ngIf="seasonDropdownOpen">
                    <div class="filter-option" [class.selected]="seasonFilter === ''" (click)="selectSeasonFilter('')">Todas las temporadas</div>
                    <div class="filter-option" *ngFor="let s of seasons" [class.selected]="seasonFilter === s.id" (click)="selectSeasonFilter(s.id)">{{ s.name }}</div>
                </div>
            </div>
            <button class="btn-clear" *ngIf="searchText || seasonFilter" (click)="clearFilters()">
                <i class="fal fa-xmark"></i> Limpiar
            </button>
        </div>
        <div class="btns-create">
            <div class="btn-create m-0" (click)="openCreate()">
                <i class="fal fa-plus-circle"></i>
                <p class="m-0">Crear producto</p>
            </div>
        </div>
    </div>

    <div *ngIf="loadingPage" class="container-lottie">
        <div class="loading-container">
            <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
                containerClass="loading-box"></ng-lottie>
        </div>
    </div>

    <div class="table-events table-panel multiple-lines desktop-view" *ngIf="loaded">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z28" matSort>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Acciones</th>
                <td mat-cell *matCellDef="let p">
                    <div [matMenuTriggerFor]="actionMenu" class="pointer-in d-flex justify-content-center"
                        style="width: 20px;">
                        <i class="icon-option fal fa-ellipsis-vertical"></i>
                    </div>
                    <mat-menu class="options-menu-control-panel" #actionMenu="matMenu">
                        <button mat-menu-item (click)="openEdit(p)"><i class="fal fa-pen-to-square" style="margin-right: 8px;"></i>Editar</button>
                        <button mat-menu-item (click)="deleteProduct(p)" class="delete-action"><i class="fal fa-trash-can" style="margin-right: 8px;"></i>Eliminar</button>
                    </mat-menu>
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header><b><i class="fal fa-tag th-icon"></i> Nombre</b></th>
                <td mat-cell *matCellDef="let p" (click)="openEdit(p)">
                    <span class="link-titulo">{{p.name}}</span>
                    <span class="admin-only-chip" *ngIf="p.admin_only"
                        title="No aparece en el alta ni en la renovación web">
                        <i class="fal fa-lock"></i> Solo panel
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef mat-sort-header><b><i class="fal fa-euro-sign th-icon"></i> Precio</b></th>
                <td mat-cell *matCellDef="let p">
                    <span class="price-display">{{p.price | number:'1.2-2'}} €</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="seasons">
                <th mat-header-cell *matHeaderCellDef><b><i class="fal fa-calendar-range th-icon"></i> Temporadas</b></th>
                <td mat-cell *matCellDef="let p">
                    <span class="season-chip" *ngFor="let name of getSeasonNames(p)">{{name}}</span>
                    <span class="no-seasons" *ngIf="getSeasonNames(p).length === 0">Sin temporada</span>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <!-- Vista de tarjetas para móvil: los mismos productos que la tabla, uno por
         tarjeta. -->
    <div class="mobile-view list-cards" *ngIf="loaded">
        <div class="list-card" *ngFor="let p of products">
            <div class="card-top">
                <p class="card-title" (click)="openEdit(p)">{{p.name}}</p>
                <div class="card-menu" [matMenuTriggerFor]="cardMenu">
                    <i class="icon-option fal fa-ellipsis-vertical"></i>
                </div>
                <mat-menu class="options-menu-control-panel" #cardMenu="matMenu">
                    <button mat-menu-item (click)="openEdit(p)"><i class="fal fa-pen-to-square" style="margin-right: 8px;"></i>Editar</button>
                    <button mat-menu-item (click)="deleteProduct(p)" class="delete-action"><i class="fal fa-trash-can" style="margin-right: 8px;"></i>Eliminar</button>
                </mat-menu>
            </div>

            <div class="card-rows">
                <div class="card-row">
                    <i class="fal fa-euro-sign"></i>
                    <span class="price-display">{{p.price | number:'1.2-2'}} €</span>
                </div>
            </div>

            <div class="card-foot">
                <span class="season-chip" *ngFor="let name of getSeasonNames(p)">{{name}}</span>
                <span class="no-seasons" *ngIf="getSeasonNames(p).length === 0">Sin temporada</span>
                <!-- No aparece en el alta ni en la renovación web. -->
                <span class="admin-only-chip" *ngIf="p.admin_only">
                    <i class="fal fa-lock"></i> Solo panel
                </span>
            </div>
        </div>
    </div>

    <div *ngIf="loaded && !loadingPage && products.length === 0" class="empty-state">
        <i class="fal fa-cart-shopping"></i>
        <p>No hay productos</p>
        <span>Crea un producto para poder cobrar el alta o la renovación de los abonos</span>
    </div>
</div>
